import React, { FC, useEffect, useState } from 'react';
import { Redirect, Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import { Payment } from '../../components/successParts/Payment';
import './Success.scss';
import { GlobalRouteNames, LocalStorageItems, SuccessRouteNames } from '../../models/Common';
import { ServiceActivated } from '../../components/successParts/ServiceActivated';
import { BrizTvCtvRequest } from '../../components/successParts/BrizTvCtvRequest';
import { ServiceSuspended } from '../../components/successParts/ServiceSuspended';
import { BrizTvPromotion } from '../../components/successParts/BrizTvPromotion';
import { ImgWebp } from '../../components/commons/ImgWeb';
import { AnimatedIcon } from '../../components/commons/AnimatedIcon';
import SuccessIconLight from '../../assets/images/lottieIcons/success/success.light.json';
import SuccessIconDark from '../../assets/images/lottieIcons/success/success.dark.json';
import SuccessPng from '../../assets/images/cartoons/Success.png';
import SuccessWebp from '../../assets/images/cartoons/Success.webp';
import { BrizTvConnected } from '../../components/successParts/BrizTvPromotion/BrizTvConnected';

interface successPages {
  component: JSX.Element;
  routePath: SuccessRouteNames;
  isExact?: boolean;
}

export const Success: FC = () => {
  const { path } = useRouteMatch();
  const location = useLocation();
  const [brizTvCredential, setBrizTvCredentials] = useState({ email: '', phone: '', password: '' });
  const isOtt = location.pathname.includes('ott') || location.pathname.includes('briztv-connected');

  useEffect(() => {
    const brizTvPhone = localStorage.getItem(LocalStorageItems.BrizTvPhone);
    const brizTvEmail = localStorage.getItem(LocalStorageItems.BrizTvEmail);
    const brizTvPassword = localStorage.getItem(LocalStorageItems.BrizTvPassword);
    if (brizTvPassword && (brizTvEmail || brizTvPhone)) {
      setBrizTvCredentials((prev) => ({
        ...prev,
        password: brizTvPassword,
        ...(!!brizTvPhone && { phone: brizTvPhone }),
        ...(!!brizTvEmail && { email: brizTvEmail }),
      }));
      localStorage.removeItem(LocalStorageItems.BrizTvEmail);
      localStorage.removeItem(LocalStorageItems.BrizTvPassword);
      localStorage.removeItem(LocalStorageItems.BrizTvPhone);
    }
  }, []);

  const ottSuccessPages: successPages[] = [
    { component: <BrizTvCtvRequest />, routePath: SuccessRouteNames.OttSuccessfulRequestPage, isExact: true },
    {
      component: (
        <BrizTvPromotion
          email={brizTvCredential.email}
          phone={brizTvCredential.phone}
          password={brizTvCredential.password}
        />
      ),
      routePath: SuccessRouteNames.BrizTvPromotion,
      isExact: true,
    },
    {
      component: <BrizTvConnected />,
      routePath: SuccessRouteNames.BrizTvConnected,
      isExact: true,
    },
  ];

  const successPages: successPages[] = [
    {
      component: <Payment />,
      routePath: SuccessRouteNames.PaymentSuccessfulPage,
      isExact: true,
    },
    { component: <ServiceActivated />, routePath: SuccessRouteNames.ServiceActivationSuccessfulPage, isExact: true },
    { component: <ServiceSuspended />, routePath: SuccessRouteNames.ServiceSuspendedSuccessfulPage, isExact: true },
  ];

  if (isOtt) {
    return (
      <div className="success_page success_page__ott page">
        <div className="success_page__container success_page__container__ott container">
          <div className="success_page__container__card card card__primary">
            <div className="success_page__ott__header">
              <ImgWebp
                webpSrc={SuccessWebp}
                fallback={SuccessPng}
                alt="success"
                className="success_page__ott__header__icon"
              />
            </div>
            <Switch>
              {ottSuccessPages.map((page) => {
                return (
                  <Route exact={!!page.isExact} path={path.concat(page.routePath)} key={page.routePath}>
                    {page.component}
                  </Route>
                );
              })}
              <Redirect to={GlobalRouteNames.HomePage} />
            </Switch>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="success_page page">
      <div className="success_page__container container">
        <div className="success_page__icon-container">
          <AnimatedIcon
            lightIcon={SuccessIconLight}
            darkIcon={SuccessIconDark}
            className="success_page__icon-container__icon"
          />
        </div>
        <Switch>
          {successPages.map((page) => {
            return (
              <Route exact={!!page.isExact} path={path.concat(page.routePath)} key={page.routePath}>
                {page.component}
              </Route>
            );
          })}
          <Redirect to={GlobalRouteNames.HomePage} />
        </Switch>
      </div>
    </div>
  );
};
